import styled from 'styled-components'

export const PdfViewer = styled.div`
  max-height: 100vh;
  overflow: auto;

  .react-pdf__Page {
    display: flex;
    justify-content: center;

    .react-pdf__Page__canvas {
      margin-top: 10px;
      margin-bottom: 10px;
      border: 1px solid var(--color-border);
    }
  }
`

export const CenteredMessage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  min-height: 100vh;
  padding: 24px;
  text-align: center;
  color: var(--color-text-primary);
`
